import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    connection: null,
    userName: null,
    displayName: null,
    email: null,
    profilePic: null,
    bannerPic: null,
    gender: null,
    about: null,
    companyName: null,
    websites: null,
    location: null,
    dob: null,
  },
  mutations: {
    setUser(state, userData) {
      Vue.$ga.set({
        userId: userData._id,
        userName: userData.userName,
      });
      Object.keys(userData).forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(state, key)) {
          state[key] = userData[key];
        }
      });
    },
    setUserProperty(state, data) {
      const [key, value] = Object.entries(data)[0];
      state[key] = value;
    },
    clearUser(state) {
      state.user = null;
      Vue.$ga.set({
        userId: null,
        userName: null,
      });
    },
  },
  actions: {
    async getLoggedInUserProfile({ commit, rootState }) {
      try {
        const fullProfileResponse = await rootState.auth.backendAxios.get('/account/profile');
        if (!fullProfileResponse.data) {
          throw new Error('Unable to retrieve profile data');
        }
        commit('setUser', fullProfileResponse.data);
      } catch (err) {
        Vue.toasted.show(err.response.data, {
          type: 'info',
          duration: 5000,
        });
      }
    },

    async getProfile({ rootState }, userName) {
      const profileResponse = await rootState.auth.backendAxios.get(`/user/profile/${userName}`);
      if (!profileResponse.data) {
        throw new Error('Unable to retrieve profile data');
      }
      return profileResponse.data;
    },
  },
};
